var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.author)?_c('AuthorView',{attrs:{"item":_vm.author}}):(!_vm.author && !_vm.loading)?_c('Center',[_vm._v("\n    Elemento Não encontrado.\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }